import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { EventBlueprintFormPresentation } from './event-blueprint-form.presentration';
import { EventBlueprintFormVM } from './event-blueprint-form.viewmodel';
import { TEventTypeLabel } from '../../../../api/events.dao';
import { IntlShape } from 'react-intl';


export type EventBlueprintFormProps = {
    accountId: number;
    blueprintId: string;
    apiCallSuccessCallback: () => void;
    deleteCompletionCallback?: () => void;
    eventTypesUsedInAccount: TEventTypeLabel[];
    intl: IntlShape;
};

export const EventBlueprintForm = withViewModel(EventBlueprintFormPresentation, async (props: EventBlueprintFormProps) => {
   const vm = new EventBlueprintFormVM(
       props.accountId,
       props.intl,
       props.apiCallSuccessCallback,
       props.deleteCompletionCallback,
       props.eventTypesUsedInAccount,
       props.blueprintId
   );
   await vm.initFormVM();

   return vm;
});
